import React from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';

import AddIcon from '@mui/icons-material/Add';

const AddEntityCard = ({ onAdd, message }) => (
  <Box width="100%" height={120}>
    <Card style={{ height: '100%' }}>
      <CardActionArea
        component="div"
        onClick={onAdd}
        disableRipple
        style={{ height: '100%' }}
      >
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          height="100%"
          color="rgba(0, 0, 0, 0.6)"
          p={4}
        >
          <AddIcon style={{ fontSize: 48 }} />
          <Typography align="center" color="inherit">
            {message}
          </Typography>
        </Box>
      </CardActionArea>
    </Card>
  </Box>
);

AddEntityCard.propTypes = {
  message: PropTypes.node.isRequired,
  onAdd: PropTypes.func.isRequired,
};

export default AddEntityCard;
